import useCasinoRoutes from '../router/use-casino-routes';

const useOgMetaRoutes = () => {
	const { ROUTE_CASINO } = useCasinoRoutes();
	const ogRoutes = {
		OG_META_CASINO_EXPLORE: `${ROUTE_CASINO}/explore`,
		OG_META_LIVE_CASINO: `${ROUTE_CASINO}/live-casino`,
		OG_META_LIVE_BETTING: '/live-betting',
		OG_META_SPORTSBOOK: '/sportsbook',
		OG_META_VIRTUAL_SPORTS: '/virtual-sports',
		OG_META_ESPORT: '/e-sport',
		OG_META_ABOUT_US: '/about',
		OG_META_INDEX: '/',
		OG_META_RESPONSIBLE_GAMING: '/responsible-gaming',
		OG_META_TERMS_CONDITIONS: '/terms-and-conditions',
		OG_META_CASINO_ALL_GAMES: `${ROUTE_CASINO}/all-games`,
		OG_META_CASINO_ALL_GAMES_HOT: `${ROUTE_CASINO}/all-games/hot`,
		OG_META_CASINO_ALL_GAMES_JACKPOT: `${ROUTE_CASINO}/all-games/jackpot`,
		OG_META_CASINO_ALL_GAMES_NEW: `${ROUTE_CASINO}/all-games/new`,
		OG_META_CASINO_MY_GAMES_LOVED: `${ROUTE_CASINO}/my-games/loved`,
		OG_META_CASINO_MY_GAMES_PLAYED_ORDER: `${ROUTE_CASINO}/my-games/playedOrder`,
		OG_META_PRIVACY_POLICY: '/privacy_policy'
	};

	const ogTextKeys = Object.keys(ogRoutes);

	return { ogRoutes, ogTextKeys };
};

export default useOgMetaRoutes;
